import _ from 'ckLodash';
import guardUtils from 'utils/guardUtils';

export default {
    editorFocus: false,
    exec: function (editor, data) {
        CKEDITOR.warn('command "wixSetHtml" has been deprecated, use "editor.WIX.setHtml" instead');
        data = data.replace(/<font (.*?)>/g, function (match, group1) {
            var prefix = '<span style="';
            var suffix = '">';
            var styles = group1
                .replace(/size="(.*?)"/g, '')
                .replace('=', ':')
                .replace(/" /g, '";')
                .replace(/"/g, '')
                .replace(/face/g, 'font-family');
            return prefix + styles + suffix;
        }).replace(/<\/font>/g, '</span>');
        data = _.trim(data).length === 0 ? '<p class="font_8"></p>' : data;
        data = guardUtils.transformGuardForSetData(data);
        data = editor.dataProcessor.toHtml(data);
        editor.editable().setHtml(data);
        if (editor.editable().getText().trim().length === 0) {
            let blockElement = editor.editable().findOne('p,h1,h2,h3,h4,h5,h6,blockquote');
            guardUtils.insertGuard(editor, blockElement);
        }
    }
};
